import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { DlrService } from '../../dlr.service';
import { startWith, map } from 'rxjs/operators';
import moment from 'moment';
import { SnackBarComponent } from 'src/app/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { UserAuditV2Service } from 'src/app/reports/user-audit-updated/user-audit-v2.service';
import { UserService } from '../../../user.service';
import { UserData } from '../../../userData';

@Component({
  selector: 'app-add-dlr-policy',
  templateUrl: './add-dlr-policy.component.html',
  styleUrls: ['./add-dlr-policy.component.scss']
})

export class AddDlrPolicyComponent implements OnInit, OnDestroy {

  @Input() countries: any[] = [];
  @Input() tabCode: string;
  @Input() actionType: number;

/*   @Output() outputPolicyEvent = new EventEmitter(); */

  /** custom theme for timepicker */
  user:       UserData;
  policyForm: FormGroup;

  fcMCC         = new FormControl(null, [Validators.required]);
  fcDlv         = new FormControl(97, [Validators.required]);
  fcUnDelExpiry = new FormControl(12, [Validators.required]);
  fcSenderRegEx = new FormControl(null);
  fcContentReEx = new FormControl(null);
  fc5s          = new FormControl(32, [Validators.required]);
  fc10s         = new FormControl(40, [Validators.required]);
  fc20s         = new FormControl(10, [Validators.required]);
  fc30s         = new FormControl(8, [Validators.required]);
  fc40s         = new FormControl(5, [Validators.required]);
  fc60s         = new FormControl(2, [Validators.required]);
  fc300s        = new FormControl(1.5, [Validators.required]);
  fc600s        = new FormControl(0.5, [Validators.required]);

  mncData: any[];

  filteredClients: Observable<any[]>;
  filteredCountries: Observable<any[]>;

  mncLoaded = false;
  unsavedChanges = false;

  dialogConfirmation: MatDialogRef<any>;
  dialogEditor: MatDialogRef<any>;

  filterSubscriptions: Subscription[] = [];

  pageName = 'DLR Policies';

  constructor(polForm: FormBuilder, private dialog: MatDialog, private dialogRef: MatDialogRef<AddDlrPolicyComponent>,
              private snackBar: MatSnackBar, private userAuditV2Service: UserAuditV2Service,
              @Inject(MAT_DIALOG_DATA) public data, private dlrService: DlrService, private userService: UserService) {

    this.policyForm = polForm.group({
      fcMCC         : this.fcMCC,
      fcDlv         : this.fcDlv,
      fcUnDelExpiry : this.fcUnDelExpiry,
      fcSenderRegEx : this.fcSenderRegEx,
      fcContentReEx : this.fcContentReEx,
      fc5s          : this.fc5s,
      fc10s         : this.fc10s,
      fc20s         : this.fc20s,
      fc30s         : this.fc30s,
      fc40s         : this.fc40s,
      fc60s         : this.fc60s,
      fc300s        : this.fc300s,
      fc600s        : this.fc600s
    });

    this.user = this.userService.getUserData();
  }

  ngOnInit() {
    if (this.data.editType) {
      if (this.data.editType === 'sid_regex') {
        this.fcSenderRegEx.patchValue(this.data.policy.sid_regex);
        this.fcSenderRegEx.disable();
      } else {
        this.fcContentReEx.patchValue(this.data.policy.dest_regex);
        this.fcContentReEx.disable();
      }
    }

    this.filteredCountries = this.fcMCC.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterMCCs(value))
      );
  }

  setToday(dateControl: FormControl) {
    dateControl.patchValue(moment.utc().format('YYYY-MM-DD'));
  }

  getClientValue(item: any) {
    if (['Global', 'All'].includes(item.name)) {
      return item.name;
    } else {
      return item.name + ' - ' + item.id;
    }
  }

  async showEditForm() {
    const { RegexEditorComponent } = await import(
      /* webpackPrefetch: true */
      '../../regex-editor/regex-editor.component'
      );

    this.dialogEditor = this.dialog.open(RegexEditorComponent, {
      width: '600px',
      disableClose: true,
      hasBackdrop: false,
      id: 'sidRegexEditor' + this.data.tab,
      data: {
        tab: this.data.tab,
        type: this.data.editType,
        code: this.data.editType === 'sid_regex' ? this.fcSenderRegEx.value : this.fcContentReEx.value,
        mode: 'Advanced'
      }
    });

    this.filterSubscriptions.push(this.dialogEditor.afterClosed().subscribe(result => {
      // console.log(result);
      if (result) {
        if (this.data.editType === 'sid_regex' ) {
          this.fcSenderRegEx.enable();
          this.fcSenderRegEx.patchValue(result);
          this.fcSenderRegEx.disable();
        } else {
          this.fcContentReEx.enable();
          this.fcContentReEx.patchValue(result);
          this.fcContentReEx.disable();
        }

      }
    }));
  }

  save(){
    let isValid = true;

    if (!this.data.editType) {

      if (!this.fcMCC.value) {
        this.fcMCC.markAsDirty();
        this.fcMCC.markAsTouched();
        isValid = false;
      }
      if (!this.fcDlv.value) {
        this.fcDlv.markAsDirty();
        this.fcDlv.markAsTouched();
        isValid = false;
      }
      if (!this.fcUnDelExpiry.value) {
        this.fcUnDelExpiry.markAsDirty();
        this.fcUnDelExpiry.markAsTouched();
        isValid = false;
      }
      if (!this.fc5s.value) {
        this.fc5s.markAsDirty();
        this.fc5s.markAsTouched();
        isValid = false;
      }
      if (!this.fc10s.value) {
        this.fc10s.markAsDirty();
        this.fc10s.markAsTouched();
        isValid = false;
      }
      if (!this.fc20s.value) {
        this.fc20s.markAsDirty();
        this.fc20s.markAsTouched();
        isValid = false;
      }
      if (!this.fc30s.value)  {
        this.fc30s.markAsDirty();
        this.fc30s.markAsTouched();
        isValid = false;
      }
      if (!this.fc40s.value) {
        this.fc40s.markAsDirty();
        this.fc40s.markAsTouched();
        isValid = false;
      }
      if (!this.fc60s.value) {
        this.fc60s.markAsDirty();
        this.fc60s.markAsTouched();
        isValid = false;
      }
      if (!this.fc300s.value) {
        this.fc300s.markAsDirty();
        this.fc300s.markAsTouched();
        isValid = false;
      }
      if (!this.fc600s.value) {
        this.fc600s.markAsDirty();
        this.fc600s.markAsTouched();
        isValid = false;
      }

      if (!isValid) {
        return false;
      }

      const policy = {
        mcc                    : this.fcMCC.value && this.fcMCC.value !== 'All'  ? Number(this.fcMCC.value.replace(/\s-\s.*/g, '')) : null,
        delivery_prcn          : parseFloat(this.fcDlv.value),
        undel_cache_expiry_hrs : Number(this.fcUnDelExpiry.value),
        sid_regex              : this.fcSenderRegEx.value || '',
        dest_regex             : this.fcContentReEx.value || '',
        delay_five             : parseFloat(this.fc5s.value),
        delay_ten              : parseFloat(this.fc10s.value),
        delay_twenty           : parseFloat(this.fc20s.value),
        delay_thirty           : parseFloat(this.fc30s.value),
        delay_forty            : parseFloat(this.fc40s.value),
        delay_sixty            : parseFloat(this.fc60s.value),
        delay_three_hundred    : parseFloat(this.fc300s.value),
        delay_six_hundred      : parseFloat(this.fc600s.value),
        user_id                : 99999
      };

      this.dlrService.insert(policy).toPromise().then((response: any) => {
        if (response && response.status === 200) {
          const ap = {
            comment: 'DLR Policy has been inserted',
            oldValue: policy
          };
          this.userAuditV2Service.createAuditRecord(this.pageName, 'insert', JSON.stringify(ap));
          this.openSnackBar(['+' + 'DLR Policy hase been inserted successfully']);
          this.close();
        } else {
          this.showMessage('Error inserting dlr policy!', 'Error');
        }
      });
    } else {
      const val = this.data.editType === 'sid_regex' ? this.fcSenderRegEx.value : this.fcContentReEx.value;
      this.close(val ? val : '');
    }
  }

  clear(regEx){
    regEx.patchValue(null);
  }

  getMCCValue(item: any) {
    return item.mcc ? item.mcc + ' - ' + item.country : 'All';
  }

  close(result?) {
    this.dialogRef.close(result);
  }

  openSnackBar(message: Array<string>) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: message
    });
  }

  async showMessage(mes: string, type) {
    const { InfoMessageComponent } = await import(
      /* webpackPrefetch: true */
      'src/app/dialogs/info-message/info-message.component'
      );

    let uniqCode = '';
    if (mes.indexOf('Error sending E-Mail') > -1) {
      uniqCode = moment().format('x').toString();
    }

    this.dialog.open(InfoMessageComponent, {
      width: '320px',
      disableClose: false,
      hasBackdrop: false,
      id: 'ratesAccountRatesInfo' + this.tabCode + uniqCode,
      data: {
        infoMessage: mes,
        type
      }
    });
  }

  ngOnDestroy() {
    this.filterSubscriptions.forEach(subsc => {
      subsc.unsubscribe();
    });
  }

  private _filterMCCs(value: string): any[] {
    if (value) {
      const filterValue = value.toLowerCase();
      const arr =  this.data.countries.filter(cli => cli.country.toLowerCase().includes(filterValue)
      || cli.mcc === null ? true : cli.mcc.toString().includes(filterValue));

      return arr;
    } else {
      return [];
    }
  }

}
